import { render, staticRenderFns } from "./AtualizarRegistros.vue?vue&type=template&id=185a3890&scoped=true&"
import script from "./AtualizarRegistros.vue?vue&type=script&lang=js&"
export * from "./AtualizarRegistros.vue?vue&type=script&lang=js&"
import style0 from "./AtualizarRegistros.vue?vue&type=style&index=0&id=185a3890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185a3890",
  null
  
)

export default component.exports